import axios from 'api/axios'
import { useEffect, useState } from 'react'

const useFetchAvisos = ({ iteration = null }) => {
  const [response, setResponse] = useState()
  const [error, setError] = useState()
  const [loading, setLoading] = useState(false)

  const fetchData = () => {
    if (loading) return
    setLoading(true)
    setError(undefined)

    axios
      .get(`/avisos`)
      .then((request_response) => {
        const data = request_response.data
        setResponse(data)
      })
      .catch((error) => setError(error))
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    if (!loading) fetchData()
  }, [iteration])

  return { response, loading, error }
}

export default useFetchAvisos
